import { render, staticRenderFns } from "./ComponentModifier.vue?vue&type=template&id=0bb88859&scoped=true&"
import script from "./ComponentModifier.vue?vue&type=script&lang=js&"
export * from "./ComponentModifier.vue?vue&type=script&lang=js&"
import style0 from "./ComponentModifier.vue?vue&type=style&index=0&id=0bb88859&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb88859",
  null
  
)

export default component.exports